import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useParams } from "react-router-dom"
import { Modal, Dropdown } from 'react-bootstrap'
import DatePicker from "react-datepicker"
import Select from "react-select"

import FilterPagination from 'pages/parts/FilterPagination'

import Rightbar from '../cheques/Rightbar'
import { httpOk, GET, PUT } from 'helpers/api'
import { formatDate, formatMoney } from 'helpers/helpers'
import CustomTooltip from "pages/parts/CustomTooltip"

function Index({ modal, clientId }) {
	const { t } = useTranslation()
	const { client_id } = useParams()

	const statuses = [
		{ 'id': 1, 'name': t('success') },
		{ 'id': -1, 'name': t('deleted') },
	]

	const [data, setData] = useState([])
	const [modalChangePayment, setModalChangePayment] = useState(false)
	const [showRightBar, setShowRightBar] = useState(false)
	const [selectedItem, setSelectedItem] = useState({})
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterData, setFilterData] = useState({
		status: 1,
		search: '',
		// start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
		// end_date: formatDate(new Date(), 'yyyy-MM-dd'),
	})
	const [pagination, setPagination] = useState({
		url: `/report-clients-history/${client_id}`,
		response: null
	})

	async function toggleRightbar(boolean = false, item, index) {
		var dataCopy = { ...data }

		for (let i = 0; i < dataCopy.data.length; i++) {
			dataCopy.data[i]['showSidebar'] = false
		}

		if (item.cheque_id) {
			if (boolean) {
				const response = await GET(`/cheques/${item.cheque_id}`, {}, { loader: true })
				if (httpOk(response)) {
					dataCopy.data[index]['showSidebar'] = boolean
					setSelectedItem(response.data)
					setShowRightBar(boolean)
				}
			} else {
				setShowRightBar(boolean)
				setSelectedItem({})
			}
		}
	}

	function toggleModalChangePayment(bool, item = {}) {
		if (bool) {
			var itemCopy = { ...item }
			itemCopy.changed_amount = itemCopy.amount

			setSelectedItem(itemCopy)
			setModalChangePayment(true)
		} else {
			setModalChangePayment(false)
		}
	}

	async function changePayment(e) {
		e.preventDefault();

		var response = await PUT('/clients-payment', selectedItem, { loader: true })

		if (httpOk(response)) {
			toggleModalChangePayment(false)
			searchWithFilter()
		}
	}

	async function searchWithFilter() {
		const response = await GET(`/report-clients-history/${modal ? clientId : client_id}`, filterData, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'response': response.data })
		}

		setDropdownIsOpen(false)
	}

	async function exportToExcel() {
		//
	}

	async function paginate(page, size) {
		setFilterData({ ...filterData, 'page': page, 'size': size })
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	function getHistoryOperation(item) {
		if (item.entity_type === 'cheques' && item.transaction_type === 'minus') {
			return {
				label: t('sold_on_credit'),
				backgroundColor: '#dc3545',
				color: '#fff'
			}
		}

		if (item.entity_type === 'cheques_return') {
			return {
				label: t('return'),
				backgroundColor: '#ffc107',
				color: '#212529'
			}
		}

		if (item.transaction_type === 'plus') {
			return {
				label: t('debt_paid'),
				backgroundColor: '#198754',
				color: '#fff'
			}
		}

		return {
			label: t('out_balance'),
			backgroundColor: '#dc3545',
			color: '#fff'
		}
	}

	useEffect(() => {
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		searchWithFilter()
	}, [filterData.search, filterData.page, filterData.size]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className={`page-header ${modal ? 'modal-page' : ''}`}>
				<div className="d-flex align-items-center">
					<h4 className="vertical-center h-100">
						{t('debtor')}
					</h4>
					<div className="vertical-center">
						<i className="uil uil-angle-double-right fz-20"></i>
					</div>
					<div className="vertical-center" title={data?.client?.client_id}>
						<h6>{data?.client?.name}</h6>
					</div>
				</div>
			</div>

			<div className={`card ${modal ? 'modal-page' : ''}`}>
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex gap-2">
							{/* <FilterSearch
								filterData={filterData}
								setFilterData={setFilterData}>
							</FilterSearch> */}
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											{/* <div className="form-group col-md-6">
												<label>{t('status')}</label>
												<Select
													isClearable
													options={users}
													value={users.find(option => option.id === Number(filterData.status)) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'status': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div> */}

											<div className="form-group col-md-6">
												<label>{t('status')}</label>
												<Select
													isClearable
													options={statuses}
													value={statuses.find(option => option.id === Number(filterData.status)) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'status': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>

										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('period')}</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.start_date ? new Date(filterData.start_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'start_date': formatDate(date, 'yyyy-MM-dd') })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
											<div className="form-group col-md-6">
												<label className="invisible">.</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.end_date ? new Date(filterData.end_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'end_date': formatDate(date, 'yyyy-MM-dd') })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
										</div>

										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary"
														onClick={() => setDropdownIsOpen(false)}>
														{t('cancel')}
													</button>
													<button className="btn btn-primary"
														onClick={() => searchWithFilter(false)}>
														{t('apply')}
													</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
							<div>
								<CustomTooltip text={t('EXCEL')}>
									<button className="btn btn-outline-primary btn-wide-2 d-none" onClick={exportToExcel}>
										<i className="uil uil-file-download-alt"></i>
									</button>
								</CustomTooltip>
							</div>
						</div>
						{/* <div>
							<div className="d-between gap-2" style={{ width: '300px' }}>
								<h5><b>{t('income')}</b>:</h5>
								<h5 className="text-end">
									<span className={`text-success`}>
										{formatMoney(data.total_amount)}
									</span>
								</h5>
							</div>
							<div className="d-between gap-2">
								<h5><b>{t('amount_of_debt')}</b>:</h5>
								<h5 className="text-end">
									<span className={`text-danger`}>
										{formatMoney(data.total_debt_amount)}
									</span>
								</h5>
							</div>
						</div> */}
					</div>

					{/* {filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{filterData.status &&
									<span className="me-2">
										<b>{t('status')}: </b>
										{findKeyFromArrayByValue(statuses, 'id', filterData.status, 'name')}
									</span>
								}
								{(filterData.start_date || filterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{filterData.start_date &&
											<span>{formatDate(filterData.start_date)}</span>
										}
										{(filterData.start_date && filterData.end_date) &&
											<b> - </b>
										}
										{filterData.end_date &&
											<span>{formatDate(filterData.end_date)}</span>
										}
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase"
									onClick={resetFilter}>
									{t('reset')}
								</button>
							</div>
						</div>
					} */}

					<div className="table-responsive">
						<table className="table table-bordered table-hover cursor mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'minWidth': '60px' }} >{t("cheque")} ID</th>
									<th style={{ 'width': '20%' }} >{t("cashier")}</th>
									<th style={{ 'width': '10%' }}>{t('type')}</th>
									<th style={{ 'minWidth': '130px' }}>{t('transaction_type')}</th>
									<th style={{ 'width': '20%' }}>{t('note')}</th>
									<th style={{ 'minWidth': '130px' }} className="text-center">{t('date')}</th>
									<th style={{ 'minWidth': '120px' }} className="text-end">{t('amount')}</th>
									{/* <th style={{ 'width': '10%' }} className="text-end">{t('paid')}</th> */}
									<th style={{ 'minWidth': '120px' }} className="text-end">{t('debt')}</th>
									{filterData.status === -1 &&
										<>
											<th style={{ 'width': '10%' }}>{t('deleted_by')}</th>
											<th style={{ 'width': '10%' }}>{t('deleted')}</th>
											<th style={{ 'width': '10%' }}>{t('deleted_note')}</th>
										</>
									}
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index} className={'cursor ' + (item.showSidebar ? 'table-tr-active' : '')}
										onClick={() => {
											if (item.cheque_id) {
												toggleRightbar(true, item, index)
											}
										}}>
										<td className="text-center">{item.row_number}</td>
										<td className="td-ellipsis">{item.cheque_id}</td>
										<td className="td-ellipsis">{item.cashier_login}</td>
										<td className="td-ellipsis">{item.payment_type_name}</td>
										<td className="td-ellipsis text-center text-nowrap"
											style={{
												fontSize: '14px',
												backgroundColor: getHistoryOperation(item).backgroundColor,
												'--bs-table-accent-bg': getHistoryOperation(item).backgroundColor,
												color: getHistoryOperation(item).color
											}}>
											{getHistoryOperation(item).label}
										</td>
										<td className="td-ellipsis">{item.note}</td>
										<td className="text-center">
											<span>{formatDate(item.created_at, 'dd.MM.yyyy HH:mm')}</span>
										</td>
										<td className={`text-end text-nowrap ${item.transaction_type === 'plus' ? 'text-success' : 'text-danger'}`}>
											<span>
												{item.transaction_type === 'plus' ? '+ ' : '- '}
												{formatMoney(item.amount)}
											</span>
										</td>
										{/* <td className={`text-end text-nowrap`}>
											<span>
												{formatMoney(item.paid)}
											</span>
										</td> */}
										<td className={`text-end text-nowrap ${item.balance >= 0 ? 'text-success' : 'text-danger'}`}>
											<span>
												{formatMoney(item.balance)}
											</span>
										</td>
										{filterData.status === -1 &&
											<>
												<td>{item.deleted_by}</td>
												<td>{formatDate(item.deleted_at)}</td>
												<td>{item.deleted_note}</td>
											</>
										}
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}>
						</FilterPagination>
					}
				</div>
			</div>

			<Rightbar showRightBar={showRightBar} setShowRightBar={setShowRightBar} selectedItem={selectedItem}></Rightbar>

			{/* MODAL CHANGE PAYMENT */}
			<Modal show={modalChangePayment} animation={false} centered dialogClassName="update-modal-width"
				backdrop="static" onHide={() => toggleModalChangePayment(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('pay')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={changePayment} autoComplete="off">
						<div className="form-group">
							<label>{t('amortization')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="amount" autoFocus
								value={selectedItem.amount ? formatMoney(selectedItem.amount) : ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'amount': e.target.value.replace(/[^0-9.]/g, '') })} />
						</div>
						<div className="d-flex w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100 me-2"
								onClick={() => toggleModalChangePayment(false)} tabIndex="-1">{t('cancel')}</button>
							<button type="submit" className="btn btn-primary w-100"
								disabled={!selectedItem.amount || !(Number(selectedItem.amount) < Number(selectedItem.changed_amount_in))}>
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL CHANGE PAYMENT */}
		</>
	)
}

export default Index
